<template>
  <v-snackbar
    :timeout="6000" top right multi-line
    v-model="snackbar"
  >
    <v-icon :color="isWarning ? 'amber' : (snackItsOk ? 'green' : 'red')" style="margin-right: 16px">
      {{isWarning ? 'info' : (snackItsOk ? 'check' : 'warning')}}
    </v-icon>
    {{ snackMessage }}
    <v-btn text color="amber" @click.native="snackActionFunction()">
      {{snackActionMessage}}
    </v-btn>
  </v-snackbar>
</template>

<script>
import eventBus from '../../utils/eventBus'

export default {
  name: 'custom-snack-bar',
  created () {
    eventBus.$off('open-custom-snack-bar')
    eventBus.$on('open-custom-snack-bar', (data) => {
      this.openSnackBar(data.message, data.itsOk, data.snackAction)
    })
  },
  data () {
    return {
      snackMessage: '',
      snackbar: false,
      snackItsOk: true,
      isWarning: false,
      snackActionMessage: 'Cerrar',
      snackActionFunction: () => { this.snackbar = false }
    }
  },
  methods: {
    openSnackBar (message, itsOk, snackAction) {
      this.snackMessage = message
      this.snackbar = true
      this.snackItsOk = itsOk
      this.isWarning = itsOk === 'warning'
      if (snackAction) {
        this.snackActionMessage = snackAction.title
        this.snackActionFunction = snackAction.action
      } else {
        this.snackActionMessage = 'Cerrar'
        this.snackActionFunction = () => { this.snackbar = false }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/snackbars/custom-snack-bar.vue